import React from "react";
import { useCart } from "../context/CartContext";

const MiniCartModal = () => {
  const { lastAddedItem, showMiniCart } = useCart();

  if (!showMiniCart || !lastAddedItem) return null;

  return (
    <div className="fixed top-20 right-5 z-50">
      <div className="bg-white shadow-lg border rounded-lg p-4 w-72 animate-fadeIn">
        <h4 className="font-semibold text-gray-800 mb-2">Producto agregado</h4>
        <div className="flex items-center gap-3">
          <img
            src={lastAddedItem.imagen}
            alt={lastAddedItem.nombre}
            className="w-16 h-16 object-cover rounded"
          />
          <div>
            <p className="text-sm font-medium text-gray-900">
              {lastAddedItem.nombre}
            </p>
            <p className="text-xs text-gray-600">
              {lastAddedItem.descripcion}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiniCartModal;
